import FastMarquee from "react-fast-marquee";
import { Flame } from "lucide-react";

const ITEMS = [
  ["P", "PUMPER"],
  ["PT", "PUMPER TANKER"],
  ["TB", "TELEBOOM"],
  ["WT", "WATER TANKER"],
  ["LP", "LADDER PLATFORM"],
  ["UP", "ULTRA LARGE PUMPER"],
  ["HZ", "HAZMAT"],
  ["R", "RESCUE"],
  ["T", "TANKER"],
  ["S", "SLIP-ON"],
  ["BA", "BREATHING APPARATUS"],
  ["CU", "CONTROL UNIT"],
];

export default function Marquee() {
  return (
    <div
      data-testid="appliance-marquee"
      aria-hidden="true"
      className="border-y border-[#1C1C1C] bg-[#0D0D0D]"
    >
      <FastMarquee speed={32} gradient={false}>
        {ITEMS.map(([code, name]) => (
          <div key={code} className="flex items-center gap-3 px-10 py-5">
            <Flame className="h-3.5 w-3.5 text-[#FF6B00]" />
            <span className="font-jb text-xs font-bold tracking-[0.3em] text-[#FF3B30]">
              {code}
            </span>
            <span className="font-jb text-xs tracking-[0.3em] text-zinc-500">
              {name}
            </span>
          </div>
        ))}
      </FastMarquee>
    </div>
  );
}
